// Quick create: one click from the freaks feed tabs starts a track or a blast.
// Both need a freak to live in, so a private default freak is created behind the scenes
// (title "<what> · dd.mm hh:mm", current location, starting now) - it can be renamed later in the editor.
// Mirrors mobile utils/quickCreate.ts.
import { FREAK_TYPE_PRIVATE } from '../constants/commonConstants';

const pad = (value) => String(value).padStart(2, '0');

export const buildQuickFreakTitle = (label, date) =>
  `${label} · ${pad(date.getDate())}.${pad(date.getMonth() + 1)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;

// reverse geocoding can come back without a place id - the API needs a map title, so fall back to the coordinates
export const withMapTitle = (map, latitude, longitude) => ({
  ...(map || {}),
  title: map?.title || `${latitude.toFixed(5)},${longitude.toFixed(5)}`,
  coordinates: map?.coordinates || { latitude, longitude },
});

export const buildQuickFreak = ({ title, context, map, startDate }) => ({
  title: title.trim(),
  description: '',
  body: ' ',
  context,
  images: [],
  videos: [],
  linksYoutube: [],
  linksFacebook: [],
  linksInstagram: [],
  linksX: [],
  route: [],
  tagList: [],
  participants: [],
  map,
  startDate,
  public: false,
  type: FREAK_TYPE_PRIVATE,
});
